import { __ } from '@wordpress/i18n';
import { RawHTML, useEffect } from "@wordpress/element";
import { useBlockProps, InnerBlocks, InspectorControls, ColorPalette } from '@wordpress/block-editor';
import { __experimentalHeading as Heading, PanelBody,  __experimentalUnitControl as UnitControl,  __experimentalNumberControl as NumberControl, GradientPicker, SelectControl } from '@wordpress/components';

export const edit = ({ clientId, attributes, setAttributes }) => {

    const {
        id,
        hfcTopbarPadding,
        hfcTopbarInnerWidth,
        hfcTopbarBGcolor,
        hfcTopbarLabelColor,
        hfcTopbarLabelSize,
        hfcTopbarGradientBG,
        hfcCountdownBorderStyle,
        hfcCountdownBorderWidth,
        hfcCountdownBorderColor,
        hfcTopbarBtnBGcolor,
        hfcTopbarBtnFontcolor,
        hfcCountdownBorderRadius,
        hfcCountdownLabelColor="#fff"
    } = attributes;

    // Set unique ID through block index.
    useEffect(() => {
        if(!id){
            let clientIdSliced = clientId.slice(clientId.lastIndexOf('-') + 1);
            setAttributes({ id: ('hfc-topbar-' + clientIdSliced) });
        }
    })

    // Defined Block Props.
    const blockProps = useBlockProps();
    const ALLOWED_BLOCKS = [
        'core/group',
        'core/columns',
        'core/column',
        'hfc-blocks/countdown-timer',
        'core/image',
        'core/button'
    ];
    const TEMPLATE = [
        ['core/group', 
            { className: 'hfc-topbar'}, [
                ['core/columns', 
                    { className: 'hfc-topbar-cols'}, 
                    [
                        ['core/column', { 
                            width: '25%',
                            className: 'hfc-topbar-col' 
                        }, 
                            [
                              ['hfc-blocks/countdown-timer', 
                                 { 
                                   className: 'hfc-custom-countdown',
                                   hfcCountdownShowSeparator: false
                                 }
                              ]
                        ]],
                        ['core/column', { 
                            width: '50%',
                            className: 'hfc-topbar-col' 
                        }, 
                           [
                            ['core/image', 
                                { 
                                  url: require('/public/img/black-friday-60.png'),
                                  alt: 'black friday', 
                                  className: 'hfc-topbar-image' 
                                }
                            ]
                        ]],
                        ['core/column', { 
                            width: '25%',
                            className: 'hfc-topbar-col' 
                        }, 
                          [
                            ['core/button', 
                                { 
                                  text: 'Grab Deal now →', 
                                  url: '#', 
                                  className: 'hfc-button' 
                                },
                            ]
                        ]]
                    ]
                ]
            ]
        ]
    ];
      
    const hfcDynamicStyles = `.frhd__component-width-90 .components-input-control__container {
        max-width: 100%;
    }
    .editor-styles-wrapper .block-editor-block-list__block:not(.hfc-button){
        max-width: 100%;
        margin: 0px;
    }
    .editor-styles-wrapper .wp-block-group__inner-container{
       max-width: 100%;
       padding: 0px;
    }
     /* Start Main Styles */
     #${id}.hfc-topbar{
      background-color: ${hfcTopbarBGcolor};
      padding: ${hfcTopbarPadding}px;
      position: relative;
     }
     #${id}.hfc-topbar .hfc-close-icon{
      position: absolute;
      right: 10px;
      top: 10px;
      fill: #fff;
      cursor: pointer;
     }
     #${id}.hfc-topbar .hfc-topbar-cols{
      max-width: ${hfcTopbarInnerWidth};
      margin: 0 auto;
    }
    #${id}.hfc-topbar .hfc-topbar-cols,
    #${id}.hfc-topbar .hfc-topbar-cols .hfc-topbar-col{
       display: flex;
       align-items: center;
       justify-content: flex-end;
       gap: 50px;
    }
    #${id}.hfc-topbar .hfc-topbar-cols .hfc-topbar-col:first-child{
       justify-content: flex-start;
    }
    #${id}.hfc-topbar .hfc-countdown .hfc-timer-box{
       background-image:${hfcTopbarGradientBG};
       border-width: ${hfcCountdownBorderWidth};
       border-style: ${hfcCountdownBorderStyle};
       border-color: ${hfcCountdownBorderColor};
       border-radius: ${hfcCountdownBorderRadius};
       justify-content: center;
       width: 60px!important;
       height: 60px;
       margin-bottom: 0px;
    }
     #${id}.hfc-topbar .hfc-topbar-col .hfc-button .wp-block-button__link{
       background-color: ${hfcTopbarBtnBGcolor};
       border-radius: 6px;
       color: ${hfcTopbarBtnFontcolor};
       font-weight: bold;
       transform: scale(1);
       transition: all 0.3s ease-in-out;
       padding: 15px 35px;
       line-height: 1.5;
   }
    #${id}.hfc-topbar .hfc-topbar-col .hfc-button:hover .wp-block-button__link{
       transform: scale(1.03);
   }
    #${id}.hfc-topbar .hfc-countdown{
       margin-top: 0px;
    }
    #${id}.hfc-topbar .hfc-countdown .hfc-timer-container {
       gap: 20px;
   }      
    #${id}.hfc-topbar .hfc-countdown .hfc-timer-box p:first-child{
       font-size: ${hfcTopbarLabelSize}!important;
       color: ${hfcTopbarLabelColor}!important;
       margin: 0px;
       line-height: 24px;
    }
    #${id}.hfc-topbar .hfc-countdown .hfc-timer-box p:last-child{
       font-size: 12px;
       color: #ffffff;
       margin: 0px;
    }
    #${id}.hfc-topbar .hfc-countdown .hfc-timer-box:not(:last-child)::after{
       top: 50% !important;
       transform: translateY(-50%);
       right: -15px !important;
       font-size: ${hfcTopbarLabelSize}!important;
       line-height: 1;
    }
    .hfc-countdown .hfc-timer-container .hfc-timer-box{
       justify-content: center!important;
    }
    .hfc-countdown .hfc-timer-container .hfc-timer-box:not(:last-child)::after{
       color: ${hfcCountdownLabelColor}!important;
    }

     /* Responsive */
    @media (max-width: 1024px){
    #${id}.hfc-topbar .hfc-topbar-cols,
    #${id}.hfc-topbar .hfc-topbar-cols .hfc-topbar-col{
       flex-direction: column;
    }
    @media (max-width: 781px){
    #${id}.hfc-topbar .hfc-countdown .hfc-timer-box{
      flex-grow: 0;
      margin: 0 auto;
    }
    #${id}.hfc-topbar .hfc-countdown .hfc-timer-box p:first-child{
       line-height: 1;
    }
    #${id}.hfc-topbar .hfc-countdown .hfc-timer-box:not(:last-child)::after{
      display: none;
    }
    }
    }`;

    return ([
        <InspectorControls key={`inspector-controls-${id}`}>
            <PanelBody
                title={__('Topbar Block Settings')}
                icon={'admin-generic'}
                initialOpen={true}
                className={'frhd__control frhd__control-query'}
            >
            <Heading className={'frhd__pb-heading'}>Topbar Padding (px) :</Heading>
            <NumberControl
                    onChange={(newValue) => setAttributes({ hfcTopbarPadding: newValue })}
                    isDragEnabled
                    value={hfcTopbarPadding}
                    className={'frhd__component frhd__component-width-90'}
            />
            <UnitControl
                    label={__('Topbar Inner Width :')}
                    onChange={newValue => setAttributes({ hfcTopbarInnerWidth: newValue })}
                    isUnitSelectTabbable
                    value={hfcTopbarInnerWidth}
                    className={'frhd__component frhd__component-width-90'}
            />
            <Heading className={'frhd__pb-heading'}>Topbar Background Color :</Heading>
                <ColorPalette
                    value={hfcTopbarBGcolor}
                    onChange={(colorValue) => setAttributes({ hfcTopbarBGcolor: colorValue })}
                    clearable={false}
            />
            <Heading className={'frhd__pb-heading'}>Label Color :</Heading>
                <ColorPalette
                    value={hfcTopbarLabelColor}
                    onChange={(colorValue) => setAttributes({hfcTopbarLabelColor: colorValue })}
                    clearable={false}
            />
            <Heading className={'frhd__pb-heading'}>Button Background Color :</Heading>
                <ColorPalette
                    value={hfcTopbarBtnBGcolor}
                    onChange={(colorValue) => setAttributes({hfcTopbarBtnBGcolor: colorValue })}
                    clearable={false}
            />
            <Heading className={'frhd__pb-heading'}>Button Font Color :</Heading>
                <ColorPalette
                    value={hfcTopbarBtnFontcolor}
                    onChange={(colorValue) => setAttributes({hfcTopbarBtnFontcolor: colorValue })}
                    clearable={false}
            />
                <UnitControl
                    label={__('Label Font Size :')}
                    onChange={newValue => setAttributes({hfcTopbarLabelSize: newValue })}
                    isUnitSelectTabbable
                    value={hfcTopbarLabelSize}
                    className={'frhd__component frhd__component-width-90'}
            />
            <Heading className={"frhd__pb-heading"}>Countdown Background Color:</Heading>
            <GradientPicker
                value={hfcTopbarGradientBG}
                onChange={(currentGradient) =>
                setAttributes({ hfcTopbarGradientBG: currentGradient })
                }
            />
            </PanelBody>
            <PanelBody
                title={__('Countdown Border')}
                icon={'admin-generic'}
                initialOpen={true}
                className={'frhd__control frhd__control-query'}
            >
                <UnitControl
                    label={__('Border Width :')}
                    onChange={(newValue) => setAttributes({ hfcCountdownBorderWidth: newValue })}
                    isUnitSelectTabbable
                    value={hfcCountdownBorderWidth}
                    className={'frhd__component frhd__component-width-90'}
                />
                <SelectControl
                    label={__('Border Style :')}
                    value={hfcCountdownBorderStyle}
                    options={[
                        { label: __('None'), value: 'none' },
                        { label: __('Solid'), value: 'solid' },
                        { label: __('Dashed'), value: 'dashed' },
                        { label: __('Dotted'), value: 'dotted' },
                        { label: __('Double'), value: 'double' },
                    ]}
                    onChange={(newValue) => setAttributes({ hfcCountdownBorderStyle: newValue })}
                    __nextHasNoMarginBottom
                />
                <Heading className={'frhd__pb-heading'}>Border Color :</Heading>
                <ColorPalette
                    value={hfcCountdownBorderColor}
                    onChange={(colorValue) => setAttributes({hfcCountdownBorderColor: colorValue })}
                    clearable={false}
                />
                <UnitControl
                    label={__('Border Radius :')}
                    value={hfcCountdownBorderRadius}
                    onChange={(newValue) => setAttributes({ hfcCountdownBorderRadius: newValue })}
                    isUnitSelectTabbable
                    className={'frhd__component frhd__component-width-90'}
                />
            </PanelBody>
        </InspectorControls>,
        <div {...blockProps} key={`${id}-main-blocks`}>
            <RawHTML>{`<style>${hfcDynamicStyles}</style>`}</RawHTML>
            <div id={id} className={'hfc-topbar'}>
                 <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    viewBox="0 0 384 512"
                    className="hfc-close-icon"
                    width="24"
                    height="24">
                    <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/>
                </svg>
                <InnerBlocks
                    allowedBlocks={ALLOWED_BLOCKS}
                    template={TEMPLATE}
                />
            </div>
        </div>
    ])
}

export const save = ({ attributes }) => {
    
    const {
        id,
        hfcTopbarPadding,
        hfcTopbarInnerWidth,
        hfcTopbarBGcolor,
        hfcTopbarLabelColor,
        hfcTopbarLabelSize,
        hfcTopbarGradientBG,
        hfcCountdownBorderStyle,
        hfcCountdownBorderWidth,
        hfcCountdownBorderColor,
        hfcTopbarBtnBGcolor,
        hfcTopbarBtnFontcolor,
        hfcCountdownBorderRadius,
        hfcCountdownLabelColor="#fff",
        hfcCountdownShowSeparator
    } = attributes;

    const hfcDynamicStyles = ` #${id}.hfc-topbar{
      background-color: ${hfcTopbarBGcolor};
      padding: ${hfcTopbarPadding}px;
      position: relative;
     }
    #${id}.hfc-topbar .hfc-close-icon{
      position: absolute;
      right: 10px;
      top: 10px;
      fill: #fff;
      cursor: pointer;
     }
    #${id}.hfc-topbar .hfc-topbar-cols,
    #${id}.hfc-topbar .wp-block-group__inner-container{
      max-width: ${hfcTopbarInnerWidth};
      margin: 0 auto;
    }
    #${id}.hfc-topbar .hfc-topbar-cols,
    #${id}.hfc-topbar .hfc-topbar-cols .hfc-topbar-col{
       display: flex;
       align-items: center;
       justify-content: flex-end;
       gap: 50px;
    }
    #${id}.hfc-topbar .hfc-topbar-cols .hfc-topbar-col:first-child{
       justify-content: flex-start;
    }
    #${id}.hfc-topbar .hfc-countdown .hfc-timer-box{
       background-image:${hfcTopbarGradientBG};
       border-width: ${hfcCountdownBorderWidth};
       border-style: ${hfcCountdownBorderStyle};
       border-color: ${hfcCountdownBorderColor};
       border-radius: ${hfcCountdownBorderRadius};
       justify-content: center;
       width: 60px!important;
       height: 60px;
       margin-bottom: 0px;
    }
    #${id}.hfc-topbar .hfc-topbar-col .hfc-button a{
       background-color: ${hfcTopbarBtnBGcolor};
       border-radius: 6px;
       color: ${hfcTopbarBtnFontcolor};
       font-weight: bold;
       transform: scale(1);
       transition: all 0.3s ease-in-out;
       padding: 15px 35px;
       line-height: 1.5;
   }
   #${id}.hfc-topbar .hfc-topbar-col .hfc-button:hover a{
       transform: scale(1.03);
   }
   #${id}.hfc-topbar .hfc-countdown{
       margin-top: 0px;
    }
    #${id}.hfc-topbar .hfc-countdown .hfc-timer-container {
      gap: 20px;
    }
    #${id}.hfc-topbar .hfc-countdown .hfc-timer-box p:first-child{
       font-size: ${hfcTopbarLabelSize}!important;
       color: ${hfcTopbarLabelColor}!important;
       margin: 0px;
       line-height: 24px;
    }
    #${id}.hfc-topbar .hfc-countdown .hfc-timer-box p:last-child{
       font-size: 12px;
       color: #ffffff;
       margin: 0px;
    }
    #${id}.hfc-topbar .hfc-countdown .hfc-timer-box:not(:last-child)::after{
       top: 50% !important;
       transform: translateY(-50%);
       right: -15px !important;
       font-size: ${hfcTopbarLabelSize}!important;
       line-height: 1;
    }
    .hfc-countdown .hfc-timer-container .hfc-timer-box{
       justify-content: center!important;
    }
    .hfc-countdown .hfc-timer-container .hfc-timer-box:not(:last-child)::after{
       color: ${hfcCountdownLabelColor}!important;
    }
    /* Responsive */
     @media (max-width: 1024px){
    #${id}.hfc-topbar .hfc-topbar-cols,
    #${id}.hfc-topbar .hfc-topbar-cols .hfc-topbar-col{
       flex-direction: column;
    }
    @media (max-width: 781px){
    #${id}.hfc-topbar .hfc-countdown .hfc-timer-box{
      flex-grow: 0;
      margin: 0 auto;
    }
    #${id}.hfc-topbar .hfc-countdown .hfc-timer-box p:first-child{
       line-height: 1;
    }
    #${id}.hfc-topbar .hfc-countdown .hfc-timer-box:not(:last-child)::after{
      display: none;
    }
    }`;

    const noticeBarScript = `
    document.addEventListener("DOMContentLoaded", function () {
        const topBar = document.getElementById("${id}");
        const closeIcon = topBar.querySelector(".hfc-close-icon");
        const localStorageKey = "hfcTopbarClosed_${id}";

        if (localStorage.getItem(localStorageKey) !== "true") {
            setTimeout(() => {
                topBar.classList.add("show");
            }, 1000);
        } else {
            topBar.style.display = "none";
        }

        closeIcon.addEventListener("click", () => {
            topBar.style.display = "none";
            localStorage.setItem(localStorageKey, "true");
        });
    });
`;


    return (
        <>
            <RawHTML>{`<style>${hfcDynamicStyles}</style>`}</RawHTML>
            <RawHTML>{`<script>${noticeBarScript}</script>`}</RawHTML>
            <div id={id} className={'hfc-topbar'}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 384 512"
                    className="hfc-close-icon"
                    width="24"
                    height="24">
                    <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
                </svg>
                <InnerBlocks.Content />
            </div>
        </>
    );
};